export default () => ({
  requiredFields: {}
})
